<template>
  <card>
    <template slot="header">
      <!-- Title -->
      <h5 class="h3 mb-0">{{ avaliationItem.name }}</h5>
    </template>
    <div v-loading="loading">
      <AvaliationNumberChart
        :avaliation-item="avaliationItem"
        :chart-data="chartData"
      />
    </div>
  </card>
</template>

<script>
import AvaliationNumberChart from './AvaliationItemDashboardCharts/AvaliationNumberChart.vue';

const STRATEGY_CHARTS = {
  number:       () => import('./AvaliationItemDashboardCharts/AvaliationNumberChart.vue'),
  date:         () => import('./AvaliationItemDashboardCharts/AvaliationDateChart.vue'),
  boolean:      () => import('./AvaliationItemDashboardCharts/AvaliationBooleanChart.vue'),
  likert_scale: () => import('./AvaliationItemDashboardCharts/AvaliationLikertSacaleChart.vue'),
  select:       () => import('./AvaliationItemDashboardCharts/AvaliationSelectChart.vue'),
};

export default {
  name: 'AvaliationItemDashboardCard',
  components: {
    AvaliationNumberChart,
  },
  props: {
    avaliationItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    chartData: {},
  }),
  mounted() {
    this.getChartData();
  },
  methods: {
    async getChartData() {
      this.loading = true;
      try {
        const { data } = await this.$http.secured.get(`/api/v1/avaliations/${this.avaliationItem.avaliation_id}/avaliation_items/${this.avaliationItem.id}/dashboard_data`);
        this.chartData = data;
      } catch (error) {
        console.error("[AvaliationItemDashboardCard][getChartData] Error getting chart data", error)
      } finally {
        this.loading = false;
      }
    },
    chartComponent() {
      return STRATEGY_CHARTS[this.avaliationItem.strategy];
    },
  },
}
</script>
